import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import Modal from '../modal/Modal';
import ButtonText from '../button/button-text/ButtonText';
import { Title } from '../typography/Heading';
import styles from './crop-image.module.less';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import { getOrReplaceImageSrc } from '../../utils/image-utils';

class CropImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            crop: {
                x: 0,
                y: 0,
                width: props.startWidth,
                aspect: props.aspect,
            },
        };
    }

    onSaveCropped = () => {
        this.props.cropImageHandler(this.state.crop);
    };

    setCropState = (crop) => {
        this.setState({
            crop,
        });
    };

    onImageLoaded = (image) => {
        this.setState({
            crop: makeAspectCrop(
                {
                    x: 0,
                    y: 0,
                    aspect: this.props.aspect,
                    width: this.props.startWidth,
                },
                image.width / image.height
            ),
        });
    };

    render() {
        const { imageUrl, isSavingCroppedImage } = this.props;
        const imageSrc = getOrReplaceImageSrc(imageUrl);

        return (
            <Modal
                contentLabel="Viser beskjæring av bilde"
                isOpen={this.props.isOpen}
                className={styles.modal}
                onRequestClose={this.props.cancelButtonHandler}
            >
                <Title tag="h1">Sett rett utsnitt på bilde</Title>
                <div className={styles.cropWrapper}>
                    {this.props.isOpen && (
                        <ReactCrop
                            src={imageSrc}
                            onChange={this.setCropState}
                            crop={isSavingCroppedImage ? {} : this.state.crop}
                            keepSelection
                            onImageLoaded={this.onImageLoaded}
                            onComplete={this.setCropState}
                            disabled={isSavingCroppedImage}
                            imageStyle={{ maxHeight: '60vh' }}
                            className={styles.cropContainer}
                        />
                    )}
                </div>
                <div className={styles.buttonContainer}>
                    <RoundedButtonPrimary
                        className={styles.primaryButton}
                        disabled={isSavingCroppedImage}
                        onClick={this.onSaveCropped}
                    >
                        {isSavingCroppedImage ? 'Lagrer …' : 'Lagre bilde'}
                    </RoundedButtonPrimary>
                    <ButtonText onClick={this.props.cancelButtonHandler} disabled={isSavingCroppedImage}>
                        Avbryt
                    </ButtonText>
                </div>
            </Modal>
        );
    }
}

CropImage.propTypes = {
    isSavingCroppedImage: PropTypes.bool,
    imageUrl: PropTypes.string,
    cropImageHandler: PropTypes.func.isRequired,
    cancelButtonHandler: PropTypes.func.isRequired,
    startWidth: PropTypes.number.isRequired,
    aspect: PropTypes.number.isRequired,
};

export default CropImage;
